const STORAGE_KEY = "ae_cookie_consent_v1";

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasConsent(category) {
  const prefs = getConsent();
  return !!(prefs && prefs[category]);
}

function applyAnalyticsConsent(prefs) {
  const ph = window.posthog;
  if (!ph || typeof ph.opt_out_capturing !== "function") return;
  try {
    if (prefs && prefs.analytics) {
      ph.opt_in_capturing();
    } else {
      ph.opt_out_capturing();
      if (typeof ph.stopSessionRecording === "function") ph.stopSessionRecording();
    }
  } catch {
    /* noop */
  }
}

applyAnalyticsConsent(getConsent());
window.addEventListener("cookie-consent-updated", (e) => applyAnalyticsConsent(e.detail));
